import colorConfig from "./color-config.json";

const COLOR_ENTRIES = colorConfig.colors;

const resolveValue = (compConfig, entry) => {
  const direct = compConfig[entry.configKey];
  if (direct != null) return direct;
  if (entry.fallbackConfigKey) {
    const fallback = compConfig[entry.fallbackConfigKey];
    if (fallback != null) return fallback;
  }
  return null;
};

const setVar = (style, cssVar, value) => {
  if (value != null) style[cssVar] = value;
};

export const buildThemeStyle = (compConfig, hasDataConfig) => {
  if (!hasDataConfig) return {};

  const style = {};

  for (const entry of COLOR_ENTRIES) {
    if (entry.derived) continue;
    const value = resolveValue(compConfig, entry);
    if (value == null) continue;
    setVar(style, entry.cssVar, value);
    if (entry.extraCssVars) {
      for (const extra of entry.extraCssVars) {
        if (entry.configKey === "colorBorder" && extra === "--theme-btn-border") {
          if (compConfig.colorBtnBorder != null) continue;
        }
        if (entry.configKey === "colorTextMuted" && extra === "--text-half-score") {
          if (compConfig.colorHalfScore != null) continue;
        }
        if (entry.configKey === "colorAccent" && extra === "--theme-background-sub") {
          if (compConfig.colorBackgroundSub != null) continue;
        }
        setVar(style, extra, value);
      }
    }
  }

  const primary = compConfig.colorPrimary;
  const highlight = compConfig.colorSecondary;
  const onPrimary = compConfig.colorOnPrimary;
  const gradientStart = compConfig.colorGradientStart ?? "#4b5563";

  if (compConfig.colorCtaGradient == null && highlight != null && primary != null) {
    setVar(
      style,
      "--theme-cta-gradient",
      `linear-gradient(180deg, ${highlight}, ${primary})`,
    );
  }

  if (compConfig.colorOnCta == null && onPrimary != null) {
    setVar(style, "--theme-on-cta", onPrimary);
  }

  if (compConfig.colorGradientStart != null || highlight != null) {
    if (style["--theme-tab-active-gradient"] == null) {
      setVar(
        style,
        "--theme-tab-active-gradient",
        `linear-gradient(164deg, ${gradientStart} -4.47%, ${highlight ?? "#0b71f9"} 100%)`,
      );
    }
  }

  if (compConfig.colorLiveShadow == null && highlight != null) {
    setVar(
      style,
      "--theme-live-shadow",
      `0 0 8px color-mix(in srgb, ${highlight} 25%, transparent)`,
    );
  }

  return style;
};

export { colorConfig };
